import React, { FunctionComponent } from 'react'
import { Modal, Grid, Text, Button, Heading } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'

interface VerifyLaterModalProps {
  show: boolean
  onClose: () => void
  onVerifyNow: () => void
  onSkip: () => void
  testNameSpace?: string
  buttonSize?: any
}

export const VerifyLaterModal: FunctionComponent<VerifyLaterModalProps> = ({
  show,
  onClose,
  onVerifyNow,
  onSkip,
  testNameSpace = 'verify-later',
  buttonSize = 'Regular',
}) => {
  const { t } = useTranslation()

  return (
    <Modal id='verify-later-modal' show={show} onClose={onClose} testNameSpace={testNameSpace}>
      <Modal.Header>
        <Grid>
          <Heading size='L'>{t('verifyIdentity:verifyLater:modal:title')}</Heading>
        </Grid>
      </Modal.Header>

      <Modal.Content>
        <Grid>
          <Text size='S'>{t('verifyIdentity:verifyLater:modal:content')}</Text>
        </Grid>
      </Modal.Content>

      <Modal.Footer>
        <Grid>
          <Button.Ghost size={buttonSize} onClick={onVerifyNow} padding='Fluid'>
            {t('verifyIdentity:verifyLater:modal:verifyNowButton')}
          </Button.Ghost>
        </Grid>
        <Grid>
          <Button.Primary size={buttonSize} onClick={onSkip} padding='Fluid'>
            {t('verifyIdentity:verifyLater:modal:skipButton')}
          </Button.Primary>
        </Grid>
      </Modal.Footer>
    </Modal>
  )
}
